module.exports = __webpack_public_path__ + "img/NOJ-logo-white.7ffc6ce1.svg";